"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var public_api_1 = require("@l2p/public-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Bonuses = function () {
    var _a, _b;
    var _c = (0, swr_hooks_1.useBonusesByType)(public_api_1.BonusType.Deposit), data = _c.data, isLoading = _c.isLoading;
    var t = (0, next_intl_1.useTranslations)('translation');
    var formState = (0, react_final_form_1.useFormState)();
    var form = (0, react_final_form_1.useForm)();
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var currentBonus = (0, react_1.useMemo)(function () { return data === null || data === void 0 ? void 0 : data[0]; }, [data]);
    var calculatedBonus = (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        var bonusObj = {
            cash: null,
            relative: null,
            freespins: null,
        };
        var maxBonusData = (_a = currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.constraints) === null || _a === void 0 ? void 0 : _a.find(function (r) { return r.type === 'MAX_BONUS'; });
        var maxBonus = (_b = maxBonusData === null || maxBonusData === void 0 ? void 0 : maxBonusData.maxBonus) === null || _b === void 0 ? void 0 : _b.find(function (b) { return b.currency === currentCurrency; });
        var maxBonusAmount = maxBonus === null || maxBonus === void 0 ? void 0 : maxBonus.amount;
        if (((_e = (_d = (_c = currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.rewards) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.addedToBalance) === null || _e === void 0 ? void 0 : _e.length) &&
            ((_h = (_g = (_f = currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.rewards) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.addedToBalance) === null || _h === void 0 ? void 0 : _h.length) > 0) {
            var amount = (_l = (_k = (_j = currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.rewards) === null || _j === void 0 ? void 0 : _j[0]) === null || _k === void 0 ? void 0 : _k.addedToBalance) === null || _l === void 0 ? void 0 : _l.find(function (item) { return item.currency === currentCurrency; });
            if (amount)
                bonusObj.cash = "".concat(amount.amount, " ").concat(currentCurrency);
        }
        if (((_o = (_m = currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.rewards) === null || _m === void 0 ? void 0 : _m[0]) === null || _o === void 0 ? void 0 : _o.relativePercent) &&
            formState.values['amount']) {
            var maxBonusByPercent = (Number(formState.values['amount']) *
                (currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.rewards[0].relativePercent)) /
                100;
            bonusObj.relative = "".concat(maxBonusAmount && maxBonusByPercent > maxBonusAmount
                ? maxBonusAmount
                : maxBonusByPercent, " ").concat(currentCurrency);
        }
        var freeRoundsCountData = (_p = currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.rewards) === null || _p === void 0 ? void 0 : _p.find(function (r) { return r.type === 'FREE_ROUNDS'; });
        var freeRoundsCount = freeRoundsCountData === null || freeRoundsCountData === void 0 ? void 0 : freeRoundsCountData.freeRoundsCount;
        if (Number(freeRoundsCount) > 0) {
            bonusObj.freespins = "".concat(freeRoundsCount, " ").concat(t('fs').toUpperCase());
        }
        if (!bonusObj.freespins && !bonusObj.cash && !bonusObj.relative)
            return null;
        return "+ ".concat(bonusObj.cash || '', " ").concat(bonusObj.relative || '', " ").concat(bonusObj.freespins || '');
    }, [t, currentBonus, formState, currentCurrency]);
    var toggleBonusAccept = (0, react_1.useCallback)(function () {
        var _a, _b;
        form.change('bonusId', ((_a = formState === null || formState === void 0 ? void 0 : formState.values) === null || _a === void 0 ? void 0 : _a['bonusId']) ? undefined : (_b = data === null || data === void 0 ? void 0 : data[0]) === null || _b === void 0 ? void 0 : _b.id);
    }, [form, formState === null || formState === void 0 ? void 0 : formState.values, data]);
    if (isLoading)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container, style: { opacity: ((_a = formState === null || formState === void 0 ? void 0 : formState.values) === null || _a === void 0 ? void 0 : _a['bonusId']) ? '1' : '0.5' } },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.yourBonusToday }, t('yourBonusToday')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusTitle }, currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.title)),
            react_1.default.createElement("div", null,
                react_1.default.createElement(ui_components_1.InputSwitch, { color: "primary", onChange: toggleBonusAccept, checked: (_b = formState === null || formState === void 0 ? void 0 : formState.values) === null || _b === void 0 ? void 0 : _b['bonusId'] }))),
        react_1.default.createElement("hr", { className: styles_module_scss_1.default.dividedLine }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.body },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus }, t('bonus')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusValue }, calculatedBonus && react_1.default.createElement("div", null, calculatedBonus)))));
};
exports.default = Bonuses;
